var css = {"button":"google-login-button-module_button__QOdY5"};

export { css as default };
